<template>
  <section class="dashboard-view">
    <div class="dashboard-shell">
      <h1>Dashboard</h1>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DashboardView'
}
</script>

<style scoped>
.dashboard-view {
  min-height: 100%;
}

.dashboard-shell {
  min-height: 18rem;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  padding: 2rem;
}

</style>
